module.exports = __webpack_public_path__ + "static/media/eggetarian.05ee21fb.svg";